// extracted by mini-css-extract-plugin
module.exports = {"Label":"NewArticle_Label__32oOM","SectionTitle":"NewArticle_SectionTitle__2AKHQ","FeatureImg":"NewArticle_FeatureImg__YP8mp","FunctionalCard":"NewArticle_FunctionalCard__3G4qK"};